import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import CloseIcon from "../../Common/CloseIcon";
import ThermalPixel from "./ThermalPixel";
import TemperatureMetricsTable from "./TemperatureMetricsTable";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const styles = {
  dialogRoot: {
    zIndex: "8000 !important",
  },
  dialogPaper: {
    minWidth: "calc(100vw - 50px)",
    minHeight: "calc(100vh - 70px)",
  },
  buttonIcon: {
    marginLeft: "auto",
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  closeIcon: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "10px",
  },
  headerCell: {
    backgroundColor: colors.cardTitleBg,
    border: `3px solid ${colors.white}`,
    minWidth: "150px",
  },
  tableContainer: {
    overflow: "auto",
    margin: "0px 24px 24px",
  },
  link: {
    color: colors.black87,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const TemperatureMetricsNew = (props) => {
  const { classes, language, lov, startTime, maxWidth, refresh } = props;
  const [showAllColumns, setShowAllColumns] = React.useState(false);
  const [focusPhotoEvent, setFocusPhotoEvent] = React.useState();

  return (
    <>
      <Grid item>
        <Grid container direction="column">
          <Grid
            item
            className="flexCenter"
            style={{
              maxWidth: maxWidth,
              justifyContent: "flex-end",
              height: "40px",
              marginLeft: "21px",
            }}
            onClick={() => setShowAllColumns(!showAllColumns)}
          >
            <span className={classes.link}>
              {I18n.get(
                showAllColumns
                  ? "site_hideAdditionalColumns"
                  : "site_viewAdditionalColumns"
              )}
            </span>
            <img
              src={
                showAllColumns ? images.arrowOpenBlack : images.arrowClosedBlack
              }
              alt="arrow"
              style={{
                marginLeft: "10px",
                transform: showAllColumns ? "rotate(270deg)" : "rotate(180deg)",
              }}
            />
          </Grid>
          <Grid
            item
            className={classes.tableContainer}
            style={{ maxWidth: maxWidth }}
          >
            {!focusPhotoEvent && (
              <TemperatureMetricsTable
                data={props.data}
                language={language}
                showAllColumns={showAllColumns}
                lov={lov}
                startTime={startTime}
                setFocusPhotoEvent={setFocusPhotoEvent}
                refresh={refresh}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
      {focusPhotoEvent && (
        <Dialog
          open={Boolean(focusPhotoEvent)}
          classes={{ paper: classes.dialogPaper, root: classes.dialogRoot }}
        >
          <Grid
            container
            direction="column"
            alignItems="stretch"
            style={{
              height: "100%",
              overflow: "hidden",
            }}
          >
            <Grid item className="flexCenter" style={{ height: "60px" }}>
              <Grid container alignItems="center">
                <Grid
                  item
                  className="text-center text-italic"
                  style={{ width: "calc(100vw - 400px)" }}
                >
                  {I18n.get("site_moveMouseOverImage")}
                </Grid>
                <Grid item xs />
                <Grid item xs={2} className={classes.closeIcon}>
                  <CloseIcon closeFunction={() => setFocusPhotoEvent()} />
                </Grid>
              </Grid>
            </Grid>
            <ThermalPixel
              event={focusPhotoEvent}
              eventGroupId={get(props.data, ["id"])}
              lov={lov}
              closeFunction={() => setFocusPhotoEvent()}
              refresh={refresh}
            />
          </Grid>
        </Dialog>
      )}
    </>
  );
};

export default withStyles(styles)(TemperatureMetricsNew);
